import styled from "styled-components/native";
import { Platform, Pressable, Text, View } from "react-native";
import { margin, flex } from "styled-system";
import { CheckboxProps } from "./types";
import { Theme } from "../../theming/types";

const setDefaultCursor = Platform.OS === "web" && `cursor: default;`;

export const StyledPressableContainer = styled(Pressable)<{
  isHovered: boolean;
  isDisabled: boolean;
  isInvalid: boolean;
  isChecked: boolean;
  isPressed: boolean;
}>`
  height: 24px;
  width: 24px;
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.white[900]};
  border-radius: ${({ theme }: { theme: Theme }) => theme.radii.s};
  border: 1px solid ${({ theme }: { theme: Theme }) => theme.colors.blue[200]};
  justify-content: center;
  align-items: center;
  box-shadow: ${({ theme }: { theme: Theme }) => theme.elevations.low};
  ${setDefaultCursor}
  ${({
    isHovered,
    isDisabled,
    theme
  }: {
    isHovered: boolean;
    isDisabled: boolean;
    theme: Theme;
  }) =>
    isHovered &&
    `
    border: 2px solid ${
      isDisabled ? theme.colors.blue[100] : theme.colors.blue_accent[500]
    };
    box-shadow: ${theme.elevations.medium};
  `}

  ${({
    isInvalid,
    isDisabled,
    theme
  }: {
    isInvalid: boolean;
    isDisabled: boolean;
    theme: Theme;
  }) =>
    isInvalid &&
    `
    border: 2px solid ${
      isDisabled ? theme.colors.blue[100] : theme.colors.orange[600]
    };
  `}

  ${({ isChecked, theme }: { isChecked: boolean; theme: Theme }) =>
    isChecked &&
    `
    background-color: ${theme.colors.blue_accent[500]};
    border: 2px solid ${theme.colors.blue_accent[500]}; 
    box-shadow: none;
  `}

  ${({ isPressed, theme }: { isPressed: boolean; theme: Theme }) =>
    isPressed &&
    `
    background-color: ${theme.colors.blue_accent[500]};
    border: 2px solid ${theme.colors.blue_accent[500]};
    box-shadow: none;
  `}

  ${({
    isDisabled,
    isChecked,
    theme
  }: {
    isDisabled: boolean;
    isChecked: boolean;
    theme: Theme;
  }) =>
    isDisabled &&
    `
    background-color: ${theme.colors.blue["000"]};
    border: ${isChecked ? "2px" : "1px"} solid ${theme.colors.blue[100]}; 
    box-shadow: none;
    ${setDefaultCursor}    
  `}
`;

export const StyledPressableLabelContainer = styled(Pressable)`
  ${setDefaultCursor}
  flex-shrink: 1;
`;

export const StyledTextLabel = styled(Text)<{ isDisabled: boolean }>`
  flex-shrink: 1;
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.regular};
  color: ${({ theme }: { theme: Theme }) => theme.colors.grey[900]};
  margin-left: ${({ theme }: { theme: Theme }) => theme.space["space-3"]};
  margin-right: ${({ theme }: { theme: Theme }) => theme.space["space-6"]};
  ${({ isDisabled, theme }: { isDisabled: boolean; theme: Theme }) =>
    isDisabled &&
    `
    color: ${theme.colors.grey[600]};
  `}
`;

export const StyledViewContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }: { theme: Theme }) => theme.space["space-4"]};
  ${margin}
`;
export const Checkbox = styled(Text).attrs<CheckboxProps>(
  (props: CheckboxProps) => ({
    alignLabel: props.flex === "start" ? "start" : "end"
  })
)<CheckboxProps>`
  ${flex}
`;

Checkbox.defaultProps = {
  alignLabel: "center"
};
